import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Candidate|Program History|External Credentials|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.OtherRequirement,
	portal: 'SP',
};

type LocNameStart = 'SPCandidateHistoryExternalCert';
export type SPCandidateHistoryExternalCertLocNames =
	| `${LocNameStart}TitlePageSection`
	| `${LocNameStart}LabelName`
	| `${LocNameStart}LabelActiveDate`
	| `${LocNameStart}LabelExpireDate`
	| `${LocNameStart}LabelUpdated`
	| `${LocNameStart}LabelReviewStatus`
	| `${LocNameStart}LabelInvalid`
	| `${LocNameStart}LabelDataProvider`
	| `${LocNameStart}LabelDocumentation`
	| `${LocNameStart}TitleTab`;

export const spCandidateHistoryExternalCertLocs: LocDefs<SPCandidateHistoryExternalCertLocNames> = {
	SPCandidateHistoryExternalCertTitlePageSection: {
		defaultValue: 'External Credentials',
		description: 'Page Section Title',
		displayPath: `${pathStart}Page Section Title`,
		displayType: 'Title',
		legacyName: 'OtherRequirement/Candidates.ExternalCerts.Title.PageSectionTitle',
		...sharedProperties,
	},
	SPCandidateHistoryExternalCertLabelName: {
		defaultValue: 'Name',
		description: 'Column heading for: Name.',
		displayPath: `${pathStart}Name`,
		displayType: 'Label',
		legacyName: 'OtherRequirement/Candidates.ExternalCerts.ColumnHeading.Name',
		...sharedProperties,
	},
	SPCandidateHistoryExternalCertLabelActiveDate: {
		defaultValue: 'Active Date',
		description: 'Column heading for: Active Date.',
		displayPath: `${pathStart}Active Date`,
		displayType: 'Label',
		legacyName: 'OtherRequirement/Candidates.ExternalCerts.ColumnHeading.ActiveDate',
		...sharedProperties,
	},
	SPCandidateHistoryExternalCertLabelExpireDate: {
		defaultValue: 'Expire Date',
		description: 'Column heading for: Expire Date.',
		displayPath: `${pathStart}Expire Date`,
		displayType: 'Label',
		legacyName: 'OtherRequirement/Candidates.ExternalCerts.ColumnHeading.ExpireDate',
		...sharedProperties,
	},
	SPCandidateHistoryExternalCertLabelUpdated: {
		defaultValue: 'Updated',
		description: 'Column heading for: Updated.',
		displayPath: `${pathStart}Updated`,
		displayType: 'Label',
		legacyName: 'OtherRequirement/Candidates.ExternalCerts.ColumnHeading.Updated',
		...sharedProperties,
	},
	SPCandidateHistoryExternalCertLabelReviewStatus: {
		defaultValue: 'Review Status',
		description: 'Column heading for: Review Status.',
		displayPath: `${pathStart}Review Status`,
		displayType: 'Label',
		legacyName: 'OtherRequirement/Candidates.ExternalCerts.ColumnHeading.ReviewStatus',
		...sharedProperties,
	},
	SPCandidateHistoryExternalCertLabelInvalid: {
		defaultValue: 'Invalid',
		description: 'Column heading for: Invalid.',
		displayPath: `${pathStart}Invalid`,
		displayType: 'Label',
		legacyName: 'OtherRequirement/Candidates.ExternalCerts.ColumnHeading.Invalid',
		...sharedProperties,
	},
	SPCandidateHistoryExternalCertLabelDataProvider: {
		defaultValue: 'Data Provider',
		description: 'Column heading for: Data Provider.',
		displayPath: `${pathStart}Data Provider`,
		displayType: 'Label',
		legacyName: 'OtherRequirement/Candidates.ExternalCerts.ColumnHeading.DataProvider',
		...sharedProperties,
	},
	SPCandidateHistoryExternalCertLabelDocumentation: {
		defaultValue: 'Documentation',
		description: 'Column heading for: Documentation.',
		displayPath: `${pathStart}Documentation`,
		displayType: 'Label',
		legacyName: 'OtherRequirement/Candidates.ExternalCerts.ColumnHeading.Documentation',
		...sharedProperties,
	},
	SPCandidateHistoryExternalCertTitleTab: {
		defaultValue: 'External Credentials',
		description: 'Tab Title',
		displayPath: `${pathStart}Tab title`,
		displayType: 'Label',
		legacyName: 'OtherRequirement/Candidates.ExternalCerts.Title.Tab',
		...sharedProperties,
	},
};

export type SPCandidateHistoryExternalCertLocType = LocMap<SPCandidateHistoryExternalCertLocNames>;
